// Slope-difficulty fill colors keyed by SlopeType variant. Each value is a
// Tailwind class string that paints child <svg> fills via the [&_svg]:
// descendant selector. The !important mirrors the original SCSS, which
// needed it to win against react-spring-lightbox and Swiper internal styles
// in some consumer surfaces.

export default {
  fillBlack: '[&_svg]:!fill-[#232323]',
  fillGreen: '[&_svg]:!fill-[#29903A]',
  fillRed: '[&_svg]:!fill-[#FF0000]',
  fillPrimary: '[&_svg]:!fill-[#006FAC]',
};
